import * as React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  asChild?: boolean;
}

const baseClass =
  "inline-flex items-center justify-center rounded-md text-sm font-medium px-4 py-2 bg-foreground text-background hover:opacity-90 disabled:pointer-events-none disabled:opacity-50";

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ asChild, className, children, ...props }, ref) => {
    if (asChild && React.isValidElement(children)) {
      const child = children as React.ReactElement<{ className?: string }>;
      return React.cloneElement(child, {
        className: `${baseClass} ${child.props.className ?? ""} ${className ?? ""}`.trim(),
        ...props,
      });
    }
    return (
      <button ref={ref} className={`${baseClass} ${className ?? ""}`.trim()} {...props}>
        {children}
      </button>
    );
  }
);
Button.displayName = "Button";
